<template>
  <node-view-wrapper as="div" style="display:flex;justify-content:center;margin-top:8px;">
    <div
        :style="{
          display: 'inline-block',
          padding: '6px 14px',
          border: '1px solid ' + node.attrs.borderColor,
          borderRadius: '20px',
          fontSize: '13px',
          textAlign: 'center',
          color: node.attrs.textColor,
          background: node.attrs.backgroundColor,
        }"
    >
      <node-view-content as="span" />
    </div>
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent, nodeViewProps } from '@tiptap/vue-3'

export default {
  name: 'HighlightBadgeNodeView',

  components: {
    NodeViewWrapper,
    NodeViewContent,
  },

  props: nodeViewProps,
}
</script>
